import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper'


class MexicoFooter extends Component {
    render() {
        return (
            <div>
                Para atención a clientes llama al 018008908105 de Lunes a Viernes de 9:00 a 18:00 Hrs.<br />
                <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                    <a href="http://n.apps4u.cc/mx/tnc-migente?offer=1" target="_blank">Términos y Condiciones</a> | <a href="http://n.apps4u.cc/mx/tnc-migente?offer=1&operator=MX_TELCEL&operatorSubmitted=Y&_next=privacy_policy.html&_extracted=f8aa5f134e28452085ae0654b2cb9d47&" target="_blank">Aviso de Privacidad</a> | <a href='' onClick={onUnsubClick} target="_blank">Cancelar Suscripción</a>
                </div>
            </div>
        );
    }
}

export default MexicoFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/mexico.js